import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (name && email && subject && message) {
      const mailtoLink = `mailto:kronara@outlook.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(`Nome: ${name}\nEmail: ${email}\nMensagem: ${message}`)}`;
      window.location.href = mailtoLink;
    } else {
      alert("Por favor, preencha todos os campos do formulário.");
    }
  };

  return (
    <div className="container py-16">
      <h1 className="section-title">Entre em Contato</h1>
      
      <div className="max-w-3xl mx-auto mb-12 text-center">
        <p className="text-lg">
          Interessado em adquirir uma peça da Kronara ou deseja uma criação personalizada? 
          Entre em contato conosco e teremos o prazer em atendê-lo.
        </p>
      </div>
      
      <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
        {/* Formulário de Contato */}
        <div className="contact-form">
          <h2 className="mb-6 text-2xl font-bold text-azul-majestoso">Envie uma Mensagem</h2>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">Nome</label>
              <input 
                type="text" 
                id="name" 
                className="form-input" 
                placeholder="Seu nome completo"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email" className="form-label">E-mail</label>
              <input 
                type="email" 
                id="email" 
                className="form-input" 
                placeholder="Seu e-mail"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="subject" className="form-label">Assunto</label>
              <select id="subject" className="form-input" required
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              >
                <option value="">Selecione uma opção</option>
                <option value="consulta">Consulta sobre peça específica</option>
                <option value="encomenda">Encomenda personalizada</option>
                <option value="informacao">Informações gerais</option>
                <option value="sugestoes">Sugestões</option>
                <option value="outro">Outro assunto</option>
              </select>
            </div>
            
            <div className="form-group">
              <label htmlFor="message" className="form-label">Mensagem</label>
              <textarea 
                id="message" 
                className="form-textarea" 
                rows={5} 
                placeholder="Descreva sua consulta em detalhes"
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="w-full btn btn-primary"
            >
              Enviar Mensagem
            </button>
          </form>
        </div>
        
        {/* Informações de Contato */}
        <div className="p-8 bg-prata-antiga rounded-lg">
          <h2 className="mb-6 text-2xl font-bold text-azul-majestoso">Informações de Contato</h2>
          
          <div className="space-y-6">
            <div>
              <h3 className="mb-2 text-lg font-semibold">E-mail</h3>
              <a 
                href="mailto:kronara@outlook.com" 
                className="text-azul-mitologico hover:underline"
              >
                kronara@outlook.com
              </a>
            </div>
            
            <div>
              <h3 className="mb-2 text-lg font-semibold">Redes Sociais</h3>
              <div className="flex space-x-4">
                {/* Instagram */}
                <a 
                  href="https://instagram.com/kronara_" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-azul-mitologico hover:text-azul-majestoso transition-colors"
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="w-6 h-6" 
                    fill="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                
                {/* YouTube */}
                <a 
                  href="https://www.youtube.com/@Kronara_Studio" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-azul-mitologico hover:text-azul-majestoso transition-colors"
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="w-6 h-6" 
                    fill="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
                
                {/* TikTok */}
                <a 
                  href="https://www.tiktok.com/@kronara_?lang=pt-BR" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-azul-mitologico hover:text-azul-majestoso transition-colors"
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="w-6 h-6" 
                    fill="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                  </svg>
                </a>
                
                {/* Pinterest */}
                <a 
                  href="https://br.pinterest.com/kronara/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-azul-mitologico hover:text-azul-majestoso transition-colors"
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="w-6 h-6" 
                    fill="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24c6.624 0 11.99-5.367 11.99-12.013C24.007 5.367 18.641.001 12.017.001z"/>
                  </svg>
                </a>
                
                {/* Threads */}
                <a 
                  href="https://www.threads.com/@kronara_" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-azul-mitologico hover:text-azul-majestoso transition-colors"
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="w-6 h-6" 
                    fill="currentColor" 
                    viewBox="0 0 192 192"
                  >
                    <path class="x19hqcy" d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"></path>
                  </svg>
                </a>
              </div>
            </div>
            
            <div>
              <h3 className="mb-2 text-lg font-semibold">Encomendas Personalizadas</h3>
              <p className="mb-4">
                Deseja uma peça única e exclusiva? Conte-nos sua visão e criaremos algo especial para você.
              </p>
              <p>
                O processo de criação personalizada inclui:
              </p>
              <ul className="pl-5 mt-2 space-y-1 list-disc">
                <li>Consulta inicial para entender sua visão</li>
                <li>Desenvolvimento de conceitos</li>
                <li>Aprovação do design final</li>
                <li>Criação da peça</li>
                <li>Entrega da sua joia exclusiva</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;


